import React, {useCallback, useEffect, useRef, useState} from 'react';

// helpers
import ConfigManager from '../../services/ConfigManager/ConfigManager';
import {useNavigate} from 'react-router-dom';

// components
import MobileSideBar from '../MobileSideBar';
import Overlay from '../Overlay';

// styles
import {
  Logo,
  IconHamburger,
  IconWrapper,
  LeftSide,
  TopBarContainer,
  IconMargin,
  TopBarWrapper,
  SCROLL_POSITION_BURGER_THRESHOLD,
} from './TopBar-styles';

const TOP = 0;
const THRESHOLD = SCROLL_POSITION_BURGER_THRESHOLD + 1;

const TopBar = () => {
  const navigate = useNavigate();
  const portalConfig = ConfigManager.getConfig();

  const topBarMenuRef = useRef<HTMLDivElement | null>(null);

  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  /**
   * Handle click outside of the menu by closing it
   * @param event
   */
  const handleClickOutside = (event: MouseEvent) => {
    const isClickOutside =
      topBarMenuRef.current &&
      !topBarMenuRef.current.contains(event.target as Node);
    if (isClickOutside) {
      setIsMobileSidebarOpen(false);
    }
  };

  /**
   * Handle the sidebar close event
   */
  const handleSideBarClose = useCallback(() => {
    setIsMobileSidebarOpen(false);
  }, []);

  useEffect(() => {
    // Add event listener to capture clicks
    document.addEventListener('mousedown', handleClickOutside);

    // Add scroll event listener to track scroll position
    const handleScroll = () => {
      if (window.scrollY >= TOP && window.scrollY <= THRESHOLD) {
        setScrollPosition(window.scrollY);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      // Cleanup event listener on component unmount
      document.removeEventListener('mousedown', handleClickOutside);
      // Cleanup scroll event listener
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  /**
   * Handle the logo click by navigating to the dashboard page
   */
  const handleLogoClick = () => {
    navigate('/dashboard');
    setIsMobileSidebarOpen(false);
  };

  /**
   * Toggle the mobile sidebar
   */
  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  return (
    <TopBarWrapper ref={topBarMenuRef}>
      <TopBarContainer>
        <IconMargin></IconMargin>
        <LeftSide>
          {portalConfig?.logo && (
            <Logo
              onClick={handleLogoClick}
              url={portalConfig?.logo}
              scrollPosition={scrollPosition}></Logo>
          )}
        </LeftSide>
        <IconWrapper
          isMobileSidebarOpen={isMobileSidebarOpen}
          scrollPosition={scrollPosition}
          onClick={toggleMobileSidebar}>
          {!isMobileSidebarOpen && <IconHamburger />}
        </IconWrapper>
      </TopBarContainer>

      {/* Mobile sidebar components */}
      <Overlay isVisible={isMobileSidebarOpen} onClick={handleSideBarClose} />
      <MobileSideBar
        isOpen={isMobileSidebarOpen}
        onClose={handleSideBarClose}
      />
    </TopBarWrapper>
  );
};

export default TopBar;
